import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { iConfigs } from '../../../components/NavBar'
import { PerfilColaborador } from '../../../components/PerfilColaborador/indesx'
import { useAuth } from '../../../contexts/AuthContext'
import { iNineBoxAvaliacao, iNomeId, iPerfilColaborador, iProcessoOnboard } from '../../../interfaces'
import { appApi } from '../../../services/appApi'
import { parseJwt } from '../../../services/token'
import { PropInvalida, useQuery } from '../../../Utils/Helper'
import { iLinhaTabela } from '../../Jornada/ReuniaoOne/Dashboard/Individual'
import { Body } from '../../Layouts/Body'
import { ModalSucess } from './Components/ModalSucess'
import { iDadoTabelaAprovacao } from './Components/TabelaAprovacao'
import { TabNineBox } from './Components/TabNineBox'
import { TabOnboard } from './Components/TabOnboard'
import { TabPDI } from './Components/TabPDI'
import { TabReuniaoOne } from './Components/TabReuniaoOne'
import { Main, MainColumn } from './styles'

export interface iDadoTabelaPDI {
  id: string
  dataFim: string
  origem: string
  totalAcoes: number
}

interface iDadoTabelaPDIAlterada extends iDadoTabelaPDI {
  totalConcluidas: number
  ultimaAvaliacao?: number
  temAcaoAtrasada: boolean
  temAcaoAlterada?: boolean
}

interface iDadoTabelaAndamento extends iDadoTabelaPDI {
  totalConcluidas: number
  ultimaAvaliacao?: number
  temAcaoAtrasada: boolean
}

export interface iTabelasPDIs {
  emAndamento: iDadoTabelaAndamento[]
  aprovacao: iDadoTabelaAprovacao[]
  emEdicao: iDadoTabelaPDIAlterada[]
}

type iLocationProp = {
  colaboradorId: string
  pdiId: string
}

export const VisulaizarTrilhaColaborador: React.FC = () => {
  const isAdm = parseJwt().adm === 'True'
  const { colaboradorId } = useParams<iLocationProp>()
  const { Permissoes } = useAuth()
  const query = useQuery()

  const [IsLoading, setIsLoading] = useState(false)
  const [IsLoadingPerfil, setIsLoadingPerfil] = useState(false)
  const [Ordenador, setOrdenador] = useState({ filtro: 0, ascendente: false })
  const [PDIs, setPDIs] = useState<iTabelasPDIs>({
    aprovacao: [],
    emAndamento: [],
    emEdicao: []
  })
  const [Reunioes, setReunioes] = useState<iLinhaTabela[]>([])
  const [ProcessoEmAndamento, setProcessoEmAndamento] = useState<iProcessoOnboard>()
  const [ProcessosFinalizados, setProcessosFinalizados] = useState<iProcessoOnboard[]>([])
  const [Colaborador, setColaborador] = useState<iPerfilColaborador>({
    avatar: '',
    email: '',
    id: '',
    liderados: [],
    nome: '',
    nomeCargo: '',
    nomeDepartamento: '',
    pares: [],
    celular: '',
    dataAdmissao: ''
  })
  const [Rh, setRh] = useState<iNomeId[]>([])

  const [ModalSucessIsOpen, setModalSucessIsOpen] = useState(false)

  const [ModelNineBox, setModelNineBox] = useState<iNineBoxAvaliacao>({
    comiteAtivo: false,
    nineBox: {
      id: '',
      padrao: false,
      areas: [],
      eixosX: [],
      eixosY: [],
      quadrantes: [],
      tags: [],
      squads: [],
      tipoMeta: 0,
      titulo: '',
      configuracaoEixoX: {
        descricao: '',
        titulo: ''
      },
      configuracaoEixoY: {
        descricao: '',
        titulo: ''
      }
    },
    comites: []
  })

  const [configuracaoEmpresa, setConfiguracaoEmpresa] = useState<iConfigs>()

  const NineBoxravadaParaAdmin: boolean = calculaPermissaoNineBox()
  const [PDItravadaParaAdmin, setPDItravadaParaAdmin] = useState(false)

  function calculaPermissaoNineBox(): boolean {
    if (parseJwt().adm === 'True') {
      if (configuracaoEmpresa?.nineBoxConfig?.visualizacaoRestringida) {
        if (configuracaoEmpresa.nineBoxConfig.usuariosPermitidos?.includes(parseJwt().cid)) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    } else {
      return true
    }
  }

  function getPermissaoPDI(): void {
    appApi.get(`PDI/AdmPodeVisualizar/${colaboradorId}`)
      .then(response => {
        if (response.status === 200) {
          setPDItravadaParaAdmin(response.data)
        }
      }).catch(err => {
        console.log(err)
      })
  }

  function getTrilha(): void {
    setProcessoEmAndamento(undefined)
    appApi.get(`ProcessoOnboard/Colaborador/${colaboradorId as string}`)
      .then(response => {
        if (response.status === 200) {
          setProcessoEmAndamento(response.data)
        }
      }).catch(err => {
        console.log(err)
        setProcessoEmAndamento(undefined)
      })
  }

  function getConfig(): void {
    appApi.get('Empresa/Configuracao')
      .then(res => setConfiguracaoEmpresa(res.data))
      .catch(err => console.log(err))
  }

  function ObterProcessos(): void {
    appApi.get(`ProcessoOnboard/${colaboradorId as string}/Processos`)
      .then(res => setProcessosFinalizados(res.data))
      .catch(err => console.log(err))
  }

  function getColaboador(): void {
    setIsLoadingPerfil(true)
    appApi.get(`Colaborador/${colaboradorId as string}/Perfil`)
      .then(response => setColaborador(response.data))
      .catch(err => console.log(err))
      .finally(() => setIsLoadingPerfil(false))
  }

  function LoadNineBox(): void {
    getColaboador()
    ObterNineBox()
  }

  function getPDIS(): void {
    appApi.get(`PDI/Perfil/${colaboradorId as string}`)
      .then(res => {
        setPDIs(res.data)
      })
      .catch(err => console.log(err))
  }

  function Load(): void {
    getTrilha()
    ObterProcessos()
    getColaboador()
  }

  function ObterRh(): void {
    appApi.get('Colaborador/Rh')
      .then(res => setRh(res.data))
      .catch(err => console.log(err))
  }

  function ObterNineBox(): void {
    appApi.get(`NineBox/Colaborador/${colaboradorId ?? ''}`)
      .then(res => setModelNineBox(res.data))
      .catch(err => console.log(err))
  }

  function ObterReunioes(): void {
    setIsLoading(true)
    appApi.get(`ReuniaoOne/Perfil/${colaboradorId ?? ''}/?ordenador=${Ordenador.filtro}&ascendente=${Ordenador.ascendente}&pagina=0&tamanho=1000`)
      .then(res => {
        setReunioes(res.data)
        setIsLoading(false)
      })
      .catch(err => { console.log(err); setIsLoading(false) })
  }

  useEffect(() => {
    Load()
    getPDIS()
    ObterRh()
    ObterReunioes()
  }, [colaboradorId])

  useEffect(() => {
    if (isAdm || !PropInvalida(Colaborador.avaliacaoNineBox)) {
      ObterNineBox()
    }
  }, [Colaborador])

  useEffect(() => {
    ObterReunioes()
  }, [Ordenador])

  useEffect(() => {
    getConfig()
    getPermissaoPDI()
  }, [])

  return (
    <Body isLoading={IsLoading}>
      <ModalSucess
        isOpen={ModalSucessIsOpen}
        onRequestClose={() => setModalSucessIsOpen(false)}
      />

      <Main>
        <PerfilColaborador
          Colaborador={Colaborador}
          nineBox={ModelNineBox.nineBox}
          reload={Load}
          IsLoading={IsLoadingPerfil}
          adminstradorVisualiza={NineBoxravadaParaAdmin}
        />

        <MainColumn padding='1rem 1rem' width='68.5%'>
          <Tabs defaultIndex={query.get('pdiId') ? Permissoes.jornada ? 1 : 0 : 0}>
            <TabList>
              {Permissoes.jornada && <Tab color={'black'} bg={'none'}>Jornada</Tab>}
              {Permissoes.desempenho && PDItravadaParaAdmin && <Tab color={'black'} bg={'none'}>PDI</Tab>}

              {Permissoes.desempenho && ModelNineBox && ModelNineBox?.nineBox?.quadrantes?.length > 0 && (isAdm || Colaborador.avaliacaoNineBox) && NineBoxravadaParaAdmin && <Tab color={'black'} bg={'none'}>9Box</Tab>}
              {Reunioes.length > 0 && <Tab color={'black'} bg={'none'}>Reunião 1:1</Tab>}
            </TabList>

            <TabPanels>
              {Permissoes.jornada && <TabPanel>
                <TabOnboard
                  Load={Load}
                  colaborador={Colaborador}
                  processoEmAndamento={ProcessoEmAndamento}
                  processosFinalizados={ProcessosFinalizados}
                  rh={Rh}
                />
              </TabPanel>}
              {Permissoes.desempenho && PDItravadaParaAdmin && <TabPanel padding={'1rem 0'}>
                <TabPDI getPdis={getPDIS} pdis={PDIs} />
              </TabPanel>}
              {Permissoes.desempenho && NineBoxravadaParaAdmin && ModelNineBox && ModelNineBox?.nineBox?.quadrantes?.length > 0 &&
                <TabPanel p={'0'} pt={'1rem'}>
                  <TabNineBox
                    colaborador={Colaborador}
                    model={ModelNineBox}
                    reload={LoadNineBox}
                  />
                </TabPanel>
              }
                <TabPanel>
                  <TabReuniaoOne tabela={Reunioes} onOrdenar={(filtro, ascendente) => setOrdenador({ ascendente: ascendente, filtro: filtro })}/>
                </TabPanel>
            </TabPanels>
          </Tabs>
        </MainColumn>
      </Main>
    </Body>
  )
}
